import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddOccasionMaster extends Component {
    state = {
        type: 'add',
        OccasionId: null,
        OccasionCode: '',
        OccasionName: '',
        OccasionType: '',
        DefaultAdjustmentPercent: null,
        IsActive: true,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.type;

        this.setState({ type });

        this.props.getMasterKeywordList("OccasionType");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetResOccasionById?OccasionId=${id}`,
                this.state.CompanyId
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tableLists !== prevProps.tableLists) {
            const Occasion = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!Occasion) return;

            this.setState({
                OccasionId: Occasion.occasionId,
                CompanyId: Occasion.companyId || this.state.CompanyId,
                OccasionCode: Occasion.occasionCode || '',
                OccasionName: Occasion.occasionName || '',
                OccasionType: Occasion.occasionType || '',
                DefaultAdjustmentPercent: Occasion.defaultAdjustmentPercent != null ? Occasion.defaultAdjustmentPercent : null,
                IsActive: Occasion.isActive != null ? Occasion.isActive : true,
            });
        }
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    onSwitchChange = (e) => {
        this.setState({
            IsActive: e.value,
            touch: true
        });
    }

    add = () => {

        if (this.state.OccasionCode === null || this.state.OccasionCode.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Occasion Code is required' });
            return;
        } else if (this.state.OccasionName === null || this.state.OccasionName.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Occasion Name is required' });
            return;
        } else if (this.state.OccasionType === null || this.state.OccasionType === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Occasion Type is required' });
            return;
        } else if (this.state.DefaultAdjustmentPercent === null || this.state.DefaultAdjustmentPercent.toString().trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Default Adjustment Percent is required' });
            return;
        }

        var data = {
            companyId: this.state.CompanyId,
            occasionCode: this.state.OccasionCode,
            occasionName: this.state.OccasionName,
            occasionType: this.state.OccasionType,
            defaultAdjustmentPercent: this.state.DefaultAdjustmentPercent,
            isActive: this.state.IsActive,
        }

        if (this.state.type === 'edit') {
            data.occasionId = this.state.OccasionId;
        }

        this.props.processDynamicData('ResOccasionMaster', this.state.type, data, 'res/GetResOccasionById?' + Companyid);
    }

    resetData = () => {
        var data = {
            type: 'add',
            OccasionId: null,
            OccasionCode: '',
            OccasionName: '',
            OccasionType: '',
            DefaultAdjustmentPercent: null,
            IsActive: true,
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/occasion/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let isEnabled = (this.state.touch === true);

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Occasion</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Occasion Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="OccasionCode" placeholder="Occasion Code" value={this.state.OccasionCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Occasion Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="OccasionName" placeholder="Occasion Name" value={this.state.OccasionName} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Occasion Type <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Occasion Type" options={this.props.OccasionType} value={this.state.OccasionType} name="OccasionType" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Default Adjustment Percent <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="DefaultAdjustmentPercent" placeholder="Default Adjustment Percent" value={this.state.DefaultAdjustmentPercent} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Is Active</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.onSwitchChange} name="IsActive" disabled={this.state.type === 'view'} />
                                </div>

                            </div>
                            <div className="p-col-12 p-lg-12">

                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/occasion/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        OccasionType: (state.keyword.OccasionType !== undefined) ? state.keyword.OccasionType : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOccasionMaster);
